<app-slide-in-right-modal
  modalTitle="Update Benchmark"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [slideOpen]="true"
  [showBackLink]="false"
  returnPath=""
>
  <div class="page__container flex flex-col pb-8">
    @if (prefillDate) {
      <p class="text-sm text-mango-gray74">Updating benchmark for <strong>{{ prefillDate }}</strong></p>
    }

    <form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="form">
      <div>
        <app-input-label labelFor="rate" labelClass="label--bottom-margin" [isRequired]="true">
          Rate
        </app-input-label>
        <input
          id="rate"
          type="number"
          step="0.0001"
          min="0"
          formControlName="rate"
          placeholder="Enter benchmark rate"
          class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
        />
      </div>

      <div class="col-start-3 justify-self-end">
        <button
          (click)="save()"
          [disabled]="form.invalid || (isLoading$ | async)!"
          [loading]="(isLoading$ | async)!"
          class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
          mango-button
        >
          @if (isLoading$ | async) {
            <span>Updating...</span>
          } @else {
            <span>Update Benchmark</span>
          }
        </button>
      </div>
    </form>
  </div>
</app-slide-in-right-modal>
